module.exports = __webpack_public_path__ + "img/6600.f6a59f91.jpg";